import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { XCircle, Home } from 'lucide-react';

const TipCancel = () => {
  return (
    <div className="min-h-screen hero-background flex items-center justify-center p-4">
      <Card className="max-w-md w-full bg-gray-800/90 backdrop-blur border-purple-500/30">
        <CardContent className="p-8 text-center">
          <div className="w-20 h-20 mx-auto mb-4 bg-gray-600/20 rounded-full flex items-center justify-center">
            <XCircle className="w-12 h-12 text-gray-400" />
          </div>
          <h2 className="text-2xl font-bold text-white mb-2">Payment Cancelled</h2>
          <p className="text-gray-400 mb-6">
            No worries! You can always support your favorite creators later.
          </p>
          
          <Link to="/">
            <Button className="bg-purple-600 hover:bg-purple-700 w-full">
              <Home className="w-4 h-4 mr-2" />
              Back to Home
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default TipCancel;
